/*
 * @desc 雷达图
 * @author yuetao
 * @param
 * @param
 */
import React, { PureComponent } from 'react';
import extend from './utils/extend';
import { colorRgb } from './utils/util';
import EchartBase from './base/EchartBase';
import { colors } from './config/config';

class BBDRadar extends PureComponent {
    constructor(props) {
        super(props);
    }

    setOption(param) {
        let {
            color =  colors.color.slice(),
            data = [],
            ...others
        } = param;

        let bgRgb = colorRgb(color[0]);
        let indicator = [], values = [];

        data.forEach(d => {
            let { name, max = 100, value } = d;
            indicator.push({ name, max });
            values.push(value);
        });

        const option = {
            color,
            title: {
                text: ''
            },
            tooltip: {},
            legend: {
                data: []
            },
            radar: {
                indicator: indicator,
                center: ['50%', '50%'],
                radius: '60%',
                splitNumber: 3,
                name: {
                    color: '#012C4B',
                    fontSize: 14,
                    fontWeight: 'normal',
                    fontFamily: 'Microsoft Yahei'
                },
                splitLine: {
                    lineStyle: {
                        color: '#E3E8EC'
                    }
                },
                axisLine: {
                    lineStyle: {
                        color: '#E3E8EC'
                    }
                },
                splitArea: {
                    areaStyle: {
                        color: [`rgba(${bgRgb}, 0.25)`, `rgba(${bgRgb}, 0.2)`, `rgba(${bgRgb}, 0.1)`]
                    }
                }
            },
            series: [{
                name: '',
                type: 'radar',
                data: [{
                    name: '',
                    symbolSize: 6,
                    areaStyle: {
                        normal: {
                            opacity: 0.35
                        }
                    },
                    value: values
                }]
            }]
        };

        let op = extend(true, {}, option, others);
        return op;
    }
    render() {
        return (
            <EchartBase option={this.setOption(this.props.option)} style = {this.props.style} />
        );
    }
}
export default BBDRadar;



// WEBPACK FOOTER //
// ./src/components/common/echarts/BBDRadar.jsx